import './styles.scss'
import { Data } from './controller';
import { Pulse } from '../../models/settings'
import ons from 'onsenui'

const {
  fieldMap
} = Data.stats

const rowActions = async (attrs, stat, actions) => {
  actions = actions.filter(action => action.visible)
  const index = await ons.openActionSheet({
    cancelable: true,
    buttons: [
      ...actions.map(action => action.title),
      { label: 'Cancel', icon: 'md-close' }
    ]
  })
  const action = actions[index]
  if(action) {
    await action.action(attrs, stat)
    m.redraw()
  }
}

const addToPulse = async (attrs, stat) => {
  const { charts } = attrs
  const chart = charts[stat]
  await Pulse.addGeo({ id: stat, geo: attrs.geo, state: attrs.state, chart })
}
const removeFromPulse = async (attrs, stat) => {
  await Pulse.removeGeo(stat)
}


const openCounty = async (attrs, stat) => {
  const { pushCounty } = attrs
  const counties = await Data.counties.fetch({ state: stat })
  const state = stat
  const stateName = Data.stats.stateNames[state] || state
  pushCounty({ ...counties, state, stateName })
}

const openCharts = (attrs, stat) => {

  const { charts, pushCharts } = attrs
  const chart = charts[stat]
  const geoName = Data.stats.stateNames[stat] || stat
  pushCharts({ geo: stat, geoName, chart })
}

var Table = {
  view: (vnode) => {
    const {
      data,
      meta,
      charts,
      motd
    } = vnode.attrs
    const { fields } = meta
    const {
      pushCounty,
      pushCharts
    } = vnode.attrs
    return m(".table-scroll",
      m("table.main-table", [
        m("thead",
          m("tr", fields.map(f => {
            const sortField = Object.keys(Data.stats.sortField)[0]
            const sortValue = Data.stats.sortField[sortField]
            return m("th[scope='col']", {
              'data-field': f,
              onclick: () => Data.stats.toggleSort(f)
            }, fieldMap[f],
              sortField === f && [
                sortValue === 1 &&
                m("ons-icon.pull-right[icon='fa-chevron-up']"),
                sortValue === -1 &&
                m("ons-icon.pull-right[icon='fa-chevron-down']")
              ]
            )
          }))
        ),
        m("tbody", data.map(row => {
          return m("tr", fields.map((f, i) => {
            let stat = row[f]
            if(stat && Number(stat) !== NaN) {
              stat = stat.toLocaleString('en')
            }
            if(i==0) {
              let hasChart = pushCharts && charts[stat]
              let hasCounty = pushCounty && stat.length === 2
              const watching = Pulse.get(stat)
              if(true || hasChart || hasCounty) {
                return m("th", m("span.link", {
                  onclick: (stat => e => {
                    rowActions(vnode.attrs, stat, [{
                      visible: hasChart,
                      title: 'View Charts',
                      action: openCharts
                    }, {
                      visible: hasCounty,
                      title: 'View Breakdown by County',
                      action: openCounty
                    }, {
                      visible: !watching,
                      title: 'Add to My Pulse',
                      action: addToPulse
                    }, {
                      visible: watching,
                      title: 'Remove from My Pulse',
                      action: removeFromPulse
                    }])
                  })(stat)
                }, stat),
                  hasChart &&
                  m("ons-icon.has-chart[icon='fa-bar-chart']", {
                    onclick: (stat => e => {
                      openCharts(vnode.attrs, stat)
                    })(stat)
                  }),
                  watching &&
                  m("ons-icon.watching[icon='md-star']"),
                )
              }
              return m("th", stat)
            }
            return m("td", stat)
          }))
        })),
      ])
    )
  }
}

let resizeInterval, oldheight
var Ticker = {
  oninit: (vnode) => {
    Data.stats.fetch(vnode.attrs)
  },
  onbeforeupdate: (vnode, old) => {
    if(vnode.attrs.geo !== old.attrs.geo) {
      Data.stats.fetch(vnode.attrs)
    }
    oldheight = 0
  },
  oncreate: (vnode) => {
    // make table fill up rest of vertical screen height
    const resize = () => {
      const vheight = document.body.clientHeight
      if(vheight !== oldheight) {
        let containers = document.querySelectorAll('.table-scroll')
        containers.forEach(tablecontainer => {
          const maxHeight = `max-height:${vheight - tablecontainer.getBoundingClientRect().y - 10}px`
          tablecontainer.setAttribute('style', maxHeight)
          oldheight = vheight
        })
      }
    }
    resizeInterval = setInterval(resize, 200)
  },
  onremove: (vnode) => {
    oldheight = 0
    clearInterval(resizeInterval)
  },
  view: (vnode) => {
    const { geo } = vnode.attrs
    if(!Data.stats.result) {
      return m("ons-progress-bar[indeterminate]")
    } else {
      return m(Table, { ...vnode.attrs, ...Data.stats.result })
    }
  }
}

export default Ticker
export { Table }
